import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useRef } from 'react';
import { propFunc, propStr } from '../../../helpers/custom-prop-types';
import { useLayoutDidMount } from '../../../helpers/use/useHook';
/**
 * スクリプト文字列を描画するコンポーネント
 * （グローバル汚染を避けるため、極力IframeComponentでラップして利用してください）
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
const ScriptComponent = (props) => {
    const { beforeAppendChild, className, component, script, src } = props;
    const ref = useRef();
    const Component = component;
    useLayoutDidMount(() => {
        if (!ref.current) {
            return;
        }
        let text = '';
        if (script) {
            // スクリプトタグそのものが渡された場合
            text = script;
        }
        else if (src) {
            // srcのみ渡された場合、タグとして整形する
            text = `<script type="text/javascript" src="${src}"></script>`;
        }
        // スクリプトタグの文字列かどうかチェック
        const isScript = text.match(/<script[\s\S]*?>[\s\S]*?<\/script>/gi);
        if (isScript) {
            // DOMに埋め込むためのスクリプトタグを生成
            const fragment = document.createRange().createContextualFragment(text);
            // 描画前にscriptタグに対して整形を行う
            beforeAppendChild(fragment);
            // DOMに追加
            ref.current.appendChild(fragment);
        }
    });
    // 対応する値が存在しない場合は何もしない
    if (!script && !src) {
        return null;
    }
    return _jsx(Component, { className: className, ref: ref });
};
ScriptComponent.propTypes = {
    beforeAppendChild: propFunc(),
    className: propStr(),
    component: propStr(),
    script: propStr(),
    src: propStr(),
};
ScriptComponent.defaultProps = {
    beforeAppendChild: () => { },
    className: '',
    component: 'div',
    script: '',
    src: '',
};
export default ScriptComponent;
